import {StoreType} from '../../../types/sharedTypes';


export const allPackageSizesSelector = (state: StoreType) => {
  return state.packageSizeReducer.packageSizesResult;
}
